import dayjs from "dayjs";
import config from "../config/config";

export const isTrialExpired = (creationDate: Date) => {
  const endTrialDate = new Date(creationDate);
  endTrialDate.setDate(endTrialDate.getDate() + config.TRIAL_DAYS);

  const diffDays = dayjs(endTrialDate).diff(dayjs(), "days");
  // console.log(creationDate, diffDays);
  return diffDays <= 0;
};
